interface Props {
    skill: string,
    onClick: (skill: string) => void,
    isChecked: boolean,
}

const SkillCard: React.FC<Props> = ({
    skill,
    onClick,
    isChecked,
}) => {
    return (
        <div
            className={`h-[30px] rounded-[5px] flex items-center m-[5px] cursor-pointer px-[5px] ${
                isChecked ? "bg-[rgba(255,232,171,1)]" : "bg-[rgba(234,234,234,1)]"
            }`}
            onClick={() => onClick(skill)}
        >
            <div className="font-bold text-[12px] leading-[14px]">
                {skill}
            </div>
            {
                isChecked ?
                <div className="ml-[10px]">
                    <img src="/images/symbols/x.svg"/>
                </div>: null
            }
        </div>
    )
}

export default SkillCard
